import { Companion_getInstance1yq7a1f60lp2k as Companion_getInstance } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
import { Companion_getInstancegk7jn4e7je7g as Companion_getInstance_0 } from './korlibs-platform-root-korlibs-platform.mjs';
import {
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class NativeSoundProvider {
  constructor() {
    this.d61_1 = 'unknown';
    this.e61_1 = false;
    this.f61_1 = Companion_getInstance().g2i_1;
    this.g61_1 = Companion_getInstance().i2i_1;
    this.h61_1 = Companion_getInstance().m2i_1;
    this.i61_1 = Companion_getInstance().g2i_1;
  }
  z2q(_set____db54di) {
    this.e61_1 = _set____db54di;
  }
  y5() {
  }
}
class DummyNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    Companion_getInstance_1();
    super();
  }
}
class Companion extends DummyNativeSoundProvider {
  constructor() {
    Companion_instance = null;
    super();
    Companion_instance = this;
  }
}
class HtmlNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    super();
    HtmlSimpleSound_getInstance().n61();
  }
}
class HtmlSimpleSound {
  constructor() {
    HtmlSimpleSound_instance = this;
    var tmp = this;
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      var this_0 = tmp_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        console.error(e);
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.j61_1 = tmp_0;
    this.k61_1 = false;
    var tmp_3 = this;
    // Inline function 'kotlin.also' call
    var this_1 = CompletableDeferred();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.sound.HtmlSimpleSound.unlockDeferred.<anonymous>' call
    var buf = ensureNotNull(HtmlSimpleSound_getInstance().j61_1).createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var events = ['keydown', 'touchstart', 'touchend', 'mousedown'];
    unlock._v = HtmlSimpleSound$unlockDeferred$lambda(events, unlock, buf, this_1);
    var inductionVariable = 0;
    var last = events.length;
    while (inductionVariable < last) {
      var e_0 = events[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_4 = document;
      var tmp_5;
      if (unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_5 = unlock._v;
      }
      tmp_4.addEventListener(e_0, tmp_5, true);
    }
    tmp_3.l61_1 = this_1;
    var tmp_6 = this;
    var tmp_7 = this.l61_1;
    tmp_6.m61_1 = isInterface(tmp_7, Deferred) ? tmp_7 : THROW_CCE();
  }
  n61() {
  }
}
//endregion
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function get_nativeSoundProvider() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  // Inline function 'kotlin.getValue' call
  var this_0 = nativeSoundProvider$delegate;
  nativeSoundProvider$factory();
  return this_0.o1();
}
var nativeSoundProvider$delegate;
function nativeSoundProvider$delegate$lambda() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp;
  if (Companion_getInstance_0().h1f()) {
    tmp = new HtmlNativeSoundProvider();
  } else {
    tmp = Companion_getInstance_1();
  }
  return tmp;
}
function nativeSoundProvider$factory() {
  return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
    return get_nativeSoundProvider();
  }, null);
}
var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
  if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
    properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
    nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
  }
}
function HtmlSimpleSound$unlockDeferred$lambda$lambda($source, $unlockDeferred) {
  return function () {
    $source.disconnect(0);
    HtmlSimpleSound_getInstance().k61_1 = true;
    console.info('Web Audio was successfully unlocked');
    $unlockDeferred.my(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$unlockDeferred$lambda($events, $unlock, $buf, $unlockDeferred) {
  return function (it) {
    var indexedObject = $events;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var e = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = document;
      var tmp_0;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_0 = $unlock._v;
      }
      tmp.removeEventListener(e, tmp_0, true);
    }
    HtmlSimpleSound_getInstance().j61_1.resume();
    var source = HtmlSimpleSound_getInstance().j61_1.createBufferSource();
    source.onended = HtmlSimpleSound$unlockDeferred$lambda$lambda(source, $unlockDeferred);
    source.buffer = $buf;
    source.connect(HtmlSimpleSound_getInstance().j61_1.destination);
    source.start(0.0);
    HtmlSimpleSound_getInstance().j61_1.resume();
    return Unit_instance;
  };
}
var HtmlSimpleSound_instance;
function HtmlSimpleSound_getInstance() {
  if (HtmlSimpleSound_instance === VOID)
    new HtmlSimpleSound();
  return HtmlSimpleSound_instance;
}
//region block: post-declaration
initMetadataForClass(NativeSoundProvider, 'NativeSoundProvider', NativeSoundProvider, VOID, [AutoCloseable]);
initMetadataForClass(DummyNativeSoundProvider, 'DummyNativeSoundProvider', DummyNativeSoundProvider);
initMetadataForCompanion(Companion);
initMetadataForClass(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', HtmlNativeSoundProvider);
initMetadataForObject(HtmlSimpleSound, 'HtmlSimpleSound', VOID, VOID, VOID, [0, 2, 1]);
//endregion
//region block: exports
export {
  get_nativeSoundProvider as get_nativeSoundProvider1b6rsunmfcp5k,
};
//endregion
